import { Builder } from '@builder.io/react';

import UnstyledTTYToday from './unstyled-tty-today';

Builder.registerComponent(UnstyledTTYToday, {
  name: 'UnstyledTTYToday',
  noWrap: true,
});
